/* Core & libraries */
import React, { useState, useRef } from "react";
import { Modal, Accordion } from "react-bootstrap";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Animated } from "react-animated-css";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import AssignIndividually from "./assignIndividually";
import UCButton from "../../components/buttons";
import { ReactComponent as AALogo } from "../../resources/images/aa-logo-mobile.svg";
import { ReactComponent as AssignSvg } from "../../resources/images/assign-individually-lep-atm.svg";
import { ReactComponent as BulkSvg } from "../../resources/images/bulk-import-lep.svg";
import { ReactComponent as NextIcon } from "../../resources/images/next-active.svg";
import { ReactComponent as ChatIcon } from "../../resources/images/chat-lep.svg";
import { ReactComponent as CloseIcon } from "../../resources/images/loyalty-close-button.svg";
import LepUnsavedChangesModal from "../modals/lepUnsavedChangesModal";
import { AA_LEP_HELP_URL } from "../../constants/appConstants";

/* Styles */
import styles from "./styles";
import generalStyles from "../../resources/styles/general";
import AtmBulkImport from "./atmBulkImport";

const LoyaltyRedeem = ({ showModal, setShowModal, initialBalance, allotmentId, onRedeemCompleted, allowConciergeKey }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const general = generalStyles({ theme });

  const [step, setStep] = useState(1);
  const [isChecked, setIsChecked] = useState(1);
  const assignIndividuallyRef = useRef(null);

  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);

  const nextStep = () => {
    if (isChecked === 1) {
      setStep(2);
    } else if (isChecked === 2) {
      setStep(3);
    }
  };

  const faqData = [
    {
      id: 1,
      title: <FormattedMessage id="loyaltyRedeem.faqTitle1" />,
      descA: <FormattedMessage id="loyaltyRedeem.faqDescA1" />,
    },
    {
      id: 2,
      title: <FormattedMessage id="loyaltyRedeem.faqTitle2" />,
      descA: <FormattedMessage id="loyaltyRedeem.faqDescA2" />,
    },
    {
      id: 3,
      title: <FormattedMessage id="loyaltyRedeem.faqTitle3" />,
      descA: <FormattedMessage id="loyaltyRedeem.faqDescA3" />,
    },
    {
      id: 4,
      title: <FormattedMessage id="loyaltyRedeem.faqTitle4" />,
      descA: <FormattedMessage id="loyaltyRedeem.faqDescA4" />,
      descB: <FormattedMessage id="loyaltyRedeem.faqDescB4" />,
    },
    {
      id: 5,
      title: <FormattedMessage id="loyaltyRedeem.faqTitle5" />,
      descA: <FormattedMessage id="loyaltyRedeem.faqDescA5" />,
    },
    // {
    //   id: 6,
    //   title: <FormattedMessage id="loyaltyRedeem.faqTitle6" />,
    //   descA: <FormattedMessage id="loyaltyRedeem.faqDescA6" />,
    //   descB: <FormattedMessage id="loyaltyRedeem.faqDescB6" />,
    // },
  ];

  const handleCloseButtonClick = () => {
    if (assignIndividuallyRef.current) {
      const isUserArrayNotEmpty =
        assignIndividuallyRef.current.hasSelectedUsers();
      if (isUserArrayNotEmpty) {
        setShowUnsavedChangesModal(true);
      } else {
        setShowModal(false);
      }
    } else {
      setShowModal(false);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      className={`${general.modal} ${classes.fullPageModal}`}
      onExited={() => {
        setStep(1);
        setIsChecked(1);
      }}
    >
      <Modal.Header>
        <div>
          <AALogo />
          <div className={classes.modalHeaderText}>
            <h6>
              <FormattedMessage id="loyaltyRedeem.headerTitle" />
            </h6>
            <span>
              <FormattedMessage id="loyaltyRedeem.headerSubtitle" />
            </span>
          </div>
        </div>
        <UCButton
          onClick={() => {
            handleCloseButtonClick(false);
          }}
          className={classes.closeBtn}
        >
          <CloseIcon className={classes.closeIcon}/>
        </UCButton>
      </Modal.Header>
      <Modal.Body>
        {step === 1 && (
          <div className={classes.bodyContainer}>
            <div className={classes.leftPanel}>
              <h2>
                <FormattedMessage id="loyaltyRedeem.title" />
              </h2>
              <h5>
                <FormattedMessage id="loyaltyRedeem.subtitle" />
              </h5>
              <div className={classes.radioWrapper}>
                <label
                  className={
                    isChecked === 1
                      ? classes.radioContainerActive
                      : classes.radioContainer
                  }
                >
                  <input
                    onChange={() => setIsChecked(1)}
                    type="radio"
                    name="radioOption"
                    id="assignIndividually"
                  />
                  <div>
                    <AssignSvg className={
                      isChecked === 1
                        ? classes.assignActive
                        : classes.assignDisabeld
                    } />
                  </div>
                  <div
                    className={
                      isChecked === 1
                        ? classes.radioTextActive
                        : classes.radioText
                    }
                  >
                    <h6>
                      <FormattedMessage id="loyaltyRedeem.assignTitle" />
                    </h6>
                    <p>
                      <FormattedMessage id="loyaltyRedeem.assignSubtitle" />
                    </p>
                  </div>
                  <div
                    className={`${
                      isChecked === 1 ? classes.checkmarkChecked : ""
                    } ${classes.checkmark}`}
                  ></div>
                </label>
                <label
                  className={
                    isChecked === 2
                      ? classes.radioContainerActive
                      : classes.radioContainer
                  }
                >
                  <input
                    onChange={() => setIsChecked(2)}
                    type="radio"
                    name="radioOption"
                    id="bulkImport"
                  />
                  <div>
                    <BulkSvg className={
                      isChecked === 2
                        ? classes.iconActive
                        : classes.iconDisabled
                    }/>
                  </div>
                  <div
                    className={
                      isChecked === 2
                        ? classes.radioTextActive
                        : classes.radioText
                    }
                  >
                    <div>
                      <h6>
                        <FormattedMessage id="loyaltyRedeem.BulkTitle" />
                      </h6>
                    </div>
                    <p>
                      <FormattedMessage id="loyaltyRedeem.BulkSubtitle" />
                    </p>
                  </div>
                  <div
                    className={`${
                      isChecked === 2 ? classes.checkmarkChecked : ""
                    } ${classes.checkmark}`}
                  ></div>
                </label>
              </div>
              <UCButton
                type="primary"
                onClick={nextStep}
                className={classes.nextBtn}
                iconEnd={<NextIcon />}
              >
                <FormattedMessage id="loyaltyRedeem.nextBtn" />
              </UCButton>
            </div>
            <div className={classes.rightPanel}>
              <h1>
                <FormattedMessage id="loyaltyRedeem.faqTitle" />
              </h1>
              <div className={classes.faqWrapper}>
                <Accordion alwaysOpen flush className={classes.accordion}>
                  {faqData.map((item, i) => (
                    <React.Fragment key={item.id}>
                      <Accordion.Item eventKey={i}>
                        <Accordion.Header>{item.title}</Accordion.Header>
                        <Accordion.Body>
                          <>
                            {item.descA}
                            {item.descB && (
                              <>
                                <br />
                                <br />
                                {item.descB}
                              </>
                            )}
                          </>
                        </Accordion.Body>
                      </Accordion.Item>
                      {i !== faqData.length - 1 && (
                        <hr className={classes.divider} />
                      )}
                    </React.Fragment>
                  ))}
                </Accordion>
              </div>
              <div className={classes.chatWrapper}>
                <div>
                  <ChatIcon />
                </div>
                <div className={classes.chatText}>
                  <h6>
                    <FormattedMessage id="loyaltyRedeem.chatTitle" />
                  </h6>
                  <p>
                    <FormattedMessage id="loyaltyRedeem.chatSubtitle" />
                  </p>
                </div>
                <Link
                  className={classes.chatBtn}
                  to={AA_LEP_HELP_URL}
                  target="_blank"
                  data-testid="chatlink"
                >
                  <FormattedMessage id="loyaltyRedeem.chatBtn" />
                </Link>
              </div>
            </div>
          </div>
        )}
        {step === 2 && (
          <Animated
            animationIn="fadeIn"
            animationOut="fadeOut"
            animationOutDuration={150}
            animationInDuration={150}
          >
            <AssignIndividually
              initialBalance={initialBalance}
              ref={assignIndividuallyRef}
              setAssignModalShow={setShowModal}
              allotmentId={allotmentId}
              onRedeemCompleted={onRedeemCompleted}
              allowConciergeKey={allowConciergeKey}
            />
          </Animated>
        )}
        {step === 3 && (
          <Animated
            animationIn="fadeIn"
            animationOut="fadeOut"
            animationOutDuration={150}
            animationInDuration={150}
          >
            <AtmBulkImport
              allotmentId={allotmentId}
              setAssignModalShow={setShowModal}
              onRedeemCompleted={onRedeemCompleted}
            />
          </Animated>
        )}
      </Modal.Body>
      <LepUnsavedChangesModal
        showUnsavedChangesModal={showUnsavedChangesModal}
        setShowUnsavedChangesModal={setShowUnsavedChangesModal}
        setAssignModalShow={setShowModal}
      />
    </Modal>
  );
};

export default LoyaltyRedeem;
